import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { Else, If, Then } from '@ledium/ui-common';
import { Grid } from '@mui/material';

import DmxChannelInput from './DmxChannelInput';
import DmxChannelSearchNextFreeButton from './DmxChannelSearchNextFreeButton';
import DmxChannelTestButton from './DmxChannelTestButton';

const DmxChannel = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    return (
        <Grid item xs={12}>
            <If condition={!!formData.readOnly}>
                <Then>
                    <span>
                        {i18n('dmx_channel')}: {formData.channel as number}
                    </span>
                </Then>
                <Else>
                    <Grid container spacing={0}>
                        <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
                            <DmxChannelInput />
                        </Grid>
                        <Grid item xs={12} md={5} sx={{ textAlign: 'center' }}>
                            <DmxChannelSearchNextFreeButton />
                        </Grid>
                        <Grid item xs={12} md={3} sx={{ textAlign: 'center' }}>
                            <DmxChannelTestButton />
                        </Grid>
                    </Grid>
                </Else>
            </If>
        </Grid>
    );
};

export default DmxChannel;
